export default __webpack_public_path__ + "static/media/IconDesc_Hoverpack.256.39cca952.png";